module.exports = __webpack_public_path__ + "img/1584406550.fcd42ef7.jpg";